import React from 'react'

import { Grid } from '@mui/material'

import { PostTypeEnum, ViewEnum } from '@professocial/professocialTypes/types/commonTypes'
import Headline from '../../../Post/modules/Headline'
import Image from '../../../Post/modules/Image'
import LinkPost from '../../../Post/modules/LinkPost'
import VideoPost from '../../../Post/modules/VideoPost'
import TextPreview from './TextPreview'
import { IPostElementProps } from '../../../../../types/types'
import InstaButtonImage from '../instagram/InstaButtonImage'
import { NetworkType } from '@3m5/sm_publish-frontend-api'

const PostContentPreview: React.FC<IPostElementProps> = (props) => {
  const post = props.post
  let postType = PostTypeEnum.MESSAGE
  if (post && post.content.image?.url) postType = PostTypeEnum.PHOTO
  if (post && post.content.video?.url) postType = PostTypeEnum.VIDEO
  if (post && post.content.link?.url) postType = PostTypeEnum.LINK

  return (
    <Grid container>
      {/* Messagepost */}
      {postType === PostTypeEnum.MESSAGE &&
        <Grid item xs={12}>
          <Headline
            networkPageId={props.networkPageId}
            post={post}
            networkType={props.networkType}
            value={post.content.headline}
            view={props.view}
            size={props.size}
          />
          {post.content.text && (
            <TextPreview
              networkPageId={props.networkPageId}
              post={post}
              networkType={props.networkType}
              value={post.content.text}
              view={props.view}
              size={props.size}
            />
          )}
          {props.networkType === NetworkType.Instagram && <InstaButtonImage />}
        </Grid>}

      {/* Photopost */}
      {postType === PostTypeEnum.PHOTO &&
        <>
          {props.networkType === NetworkType.Instagram && (
            <Grid item xs={12}>
              {post.content.image &&
                <Image
                  style={{ maxWidth: 'inherit', width: '100%' }}
                  data={post.content.image.url}
                  view={props.view}
                />}
              <img style={{ maxWidth: 'inherit', width: '100%' }} src='/src/shared/assets/images/instagram-buttons.png' alt='' />
              {post.content.text && (
                <TextPreview
                  networkPageId={props.networkPageId}
                  post={post}
                  networkType={props.networkType}
                  value={post.content.text}
                  view={props.view}
                  size={props.size}
                />
              )}
              <img style={{ maxWidth: '100%' }} src='/src/shared/assets/images/instagram-comments.png' alt='' />
            </Grid>
          )}
          {(props.networkType === NetworkType.Facebook || props.networkType === NetworkType.LinkedIn) && (
            <Grid item xs={12}>
              <Headline
                networkPageId={props.networkPageId}
                post={post}
                networkType={props.networkType}
                value={post.content.headline}
                view={props.view}
                size={props.size}
              />
              {post.content.text && (
                <TextPreview
                  networkPageId={props.networkPageId}
                  post={post}
                  networkType={props.networkType}
                  value={post.content.text}
                  view={props.view}
                  size={props.size}
                />
              )}
              {post.content.image &&
                <Image
                  style={{ maxWidth: 'inherit', width: '100%' }}
                  data={post.content.image.url}
                  view={props.view}
                />}
            </Grid>
          )}
        </>}
      {/* Linkpost */}
      {postType === PostTypeEnum.LINK &&
        <Grid item xs={12}>
          <Headline
            networkPageId={props.networkPageId}
            post={post}
            networkType={props.networkType}
            value={post.content.headline}
            view={props.view}
            size={props.size}
          />
          {post.content.text && (
            <TextPreview
              networkPageId={props.networkPageId}
              post={post}
              networkType={props.networkType}
              value={post.content.text}
              view={props.view}
              size={props.size}
            />
          )}
          {post.content.link &&
            <LinkPost
              networkPageId={props.networkPageId}
              post={post}
              networkType={props.networkType}
              value={post.content.link}
              view={props.view}
            />}
        </Grid>}
      {/* Videopost */}
      {postType === PostTypeEnum.VIDEO &&
        <Grid item xs={12}>
          {post.content.text && (
            <TextPreview
              networkPageId={props.networkPageId}
              post={post}
              networkType={props.networkType}
              value={post.content.text}
              view={props.view}
              size={props.size}
            />
          )}
          {post.content.video &&
            <VideoPost
              value={post.content.video}
              view={ViewEnum.preview}
            />}
          {props.networkType === NetworkType.Instagram && <img style={{ maxWidth: 'inherit', width: '100%' }} src='/src/shared/assets/images/instagram-buttons.png'
            alt=''/>}
        </Grid>}
    </Grid>
  )
}

export default PostContentPreview
